// Messages for operator/settings/Integrations (auto-merged into the i18n catalog by lib/i18n.ts).
export const en = {
  'operator.integrations.head': 'Integrations — Operator',
  'operator.integrations.all_settings': 'All settings',
  'operator.integrations.title': 'Integrations',
  'operator.integrations.desc': 'Connect external services',
  'operator.integrations.badge.connected': 'Connected',
  'operator.integrations.badge.available': 'Available',
  'operator.integrations.badge.roadmap': 'Roadmap',
  'operator.integrations.card.manage': 'Manage routing, events & templates',
  'operator.integrations.card.soon': 'Coming soon',
  'operator.integrations.note':
    'Connectors are global for Geo4Logistics. Credentials are encrypted at rest and never returned to the browser.',
  'operator.integrations.connect_title': 'Connect {name}',
  'operator.integrations.manage_title': 'Manage {name}',
  'operator.integrations.status': 'Status',
  'operator.integrations.name': 'Name',
  'operator.integrations.target_url': 'Target URL / endpoint',
  'operator.integrations.inbound_service': 'Inbound service',
  'operator.integrations.inbound_product': 'Inbound product',
  'operator.integrations.signing_secret': 'Signing secret / API key',
  'operator.integrations.connect': 'Connect',
  'operator.integrations.save': 'Save changes',
  'operator.integrations.cancel': 'Cancel',
  'operator.integrations.disable': 'Disable',
  'operator.integrations.enable': 'Enable',
  'operator.integrations.remove': 'Remove',
}

export const zhTW = {
  'operator.integrations.head': '整合 — 操作端',
  'operator.integrations.all_settings': '所有設定',
  'operator.integrations.title': '整合',
  'operator.integrations.desc': '連接外部服務',
  'operator.integrations.badge.connected': '已連接',
  'operator.integrations.badge.available': '可使用',
  'operator.integrations.badge.roadmap': '規劃中',
  'operator.integrations.card.manage': '管理路由、事件與範本',
  'operator.integrations.card.soon': '即將推出',
  'operator.integrations.note':
    '連接器為 Geo4Logistics 全域設定。憑證以加密方式靜態儲存，絕不回傳至瀏覽器。',
  'operator.integrations.connect_title': '連接 {name}',
  'operator.integrations.manage_title': '管理 {name}',
  'operator.integrations.status': '狀態',
  'operator.integrations.name': '名稱',
  'operator.integrations.target_url': '目標 URL／端點',
  'operator.integrations.inbound_service': '傳入服務',
  'operator.integrations.inbound_product': '傳入產品',
  'operator.integrations.signing_secret': '簽署密鑰／API 金鑰',
  'operator.integrations.connect': '連接',
  'operator.integrations.save': '儲存變更',
  'operator.integrations.cancel': '取消',
  'operator.integrations.disable': '停用',
  'operator.integrations.enable': '啟用',
  'operator.integrations.remove': '移除',
}
